<template>
  <div class="w-full bg-white font-['Poppins'] min-h-screen">
    <ToastAlert
      :is-active="toastAlert"
      :type="typeMsg"
      :message="msg"
      :title="tittle"
    />
    
    <!-- LOADER -->
    <div v-if="loader_profile" class="fixed inset-0 flex items-center justify-center bg-white z-50">
      <img
        src="@/assets/imgs/tuin_loader_v2.gif"
        alt="cargando..."
        class="w-full max-w-[500px] px-4"
      >
    </div>

    <!-- Contenedor principal con padding responsive -->
    <div v-show="!showModal">
      <div class="w-full px-4 sm:px-6 lg:px-20 py-6 lg:py-10">
        
        <!-- Header de selección de plan -->
        <div class="flex flex-col items-center justify-center mb-8 lg:mb-12">
          <div class="w-full max-w-[720px] text-center mb-4">
            <h1 class="text-stone-950 text-xl sm:text-2xl font-medium leading-7">
              Selecciona tu plan
            </h1>
          </div>
          
          <!-- Toggle Mensual/Anual -->
          <div class="flex items-center gap-2">
            <span class="text-stone-950 text-sm sm:text-base font-medium">
              Mensual
            </span>
            <button 
              @click="togglePeriod"
              class="relative w-10 h-5 bg-gray-200 rounded-full transition-colors duration-200"
              :class="{ 'bg-rose-500': isAnual }"
            >
              <div 
                class="absolute w-4 h-4 bg-white rounded-full top-[2px] transition-transform duration-200"
                :class="isAnual ? 'translate-x-[22px]' : 'translate-x-[2.5px]'"
              ></div>
            </button>
            <div class="flex items-center gap-1.5">
              <span class="text-neutral-500 text-sm sm:text-base font-medium">
                Anual
              </span>
              <span class="bg-rose-600 text-white text-[10px] sm:text-xs font-semibold px-2 py-0.5 rounded-md shadow-sm animate-bounce">
                -20%
              </span>
            </div>
          </div>
        </div>

        <!-- Grid de planes -->
        <div class="w-full max-w-[800px] mx-auto">
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-2 gap-10 justify-items-center">
            
            <!-- Plan 3 propiedades -->
            <div class="w-full max-w-[384px] p-6 sm:p-8 bg-white rounded-lg shadow-md border border-gray-200 flex flex-col">
              <div class="flex-1 flex flex-col gap-7">
                <!-- Título y precio -->
                <div class="flex flex-col gap-4">
                  <div class="w-full">
                    <h3 class="text-gray-500 text-lg sm:text-xl font-medium">
                      3 propiedades
                    </h3>
                  </div>
                  <div class="flex items-end gap-2.5">
                    <span class="text-gray-900 text-4xl sm:text-5xl font-extrabold leading-[48px]">
                      ${{ isAnual ? '1,430' : '149' }}
                    </span>
                    <span class="text-gray-500 text-base sm:text-lg font-medium">
                      MXN/{{ isAnual ? 'Anual' : 'Mensual' }}
                    </span>
                  </div>
                </div>

                <!-- Features -->
                <div class="flex flex-col gap-4">
                  <div class="flex items-center gap-3">
                    <div class="w-5 h-5 flex items-center justify-center">
                      <div class="w-3.5 h-3.5 bg-rose-500 rounded-sm"></div>
                    </div>
                    <span class="text-gray-500 text-sm sm:text-base">
                      3 propiedades
                    </span>
                  </div>
                  <div class="flex items-center gap-3">
                    <div class="w-5 h-5 flex items-center justify-center">
                      <div class="w-3.5 h-3.5 bg-rose-500 rounded-sm"></div>
                    </div>
                    <span class="text-gray-500 text-sm sm:text-base">
                      Exposición automática en 6 portales
                    </span>
                  </div>
                </div>

                <!-- Botón -->
                <fwb-button
                  @click="() => goToStripe('plan3')"
                  :disabled="!isActiveLocation"
                  class="w-full flex justify-center items-center px-5 py-2.5 bg-rose-500 hover:bg-rose-600 rounded-lg transition-colors duration-200 cursor-pointer"
                >
                  <span class="text-white text-sm font-medium">Cambiar de Plan</span>
                </fwb-button>
              </div>
            </div>

            <!-- Plan 5 propiedades -->
            <div class="w-full max-w-[384px] p-6 sm:p-8 bg-white rounded-lg shadow-md border border-gray-200 flex flex-col">
              <div class="flex-1 flex flex-col gap-7">
                <div class="flex flex-col gap-4">
                  <div class="w-full">
                    <h3 class="text-gray-500 text-lg sm:text-xl font-medium">
                      5 propiedades
                    </h3>
                  </div>
                  <div class="flex items-end gap-2.5">
                    <span class="text-gray-900 text-4xl sm:text-5xl font-extrabold leading-[48px]">
                      ${{ isAnual ? '1,910' : '199' }}
                    </span>
                    <span class="text-gray-500 text-base sm:text-lg font-medium">
                      MXN/{{ isAnual ? 'Anual' : 'Mensual' }}
                    </span>
                  </div>
                </div>

                <div class="flex flex-col gap-4">
                  <div class="flex items-center gap-3">
                    <div class="w-5 h-5 flex items-center justify-center">
                      <div class="w-3.5 h-3.5 bg-rose-500 rounded-sm"></div>
                    </div>
                    <span class="text-gray-500 text-sm sm:text-base">
                      5 propiedades
                    </span>
                  </div>
                  <div class="flex items-center gap-3">
                    <div class="w-5 h-5 flex items-center justify-center">
                      <div class="w-3.5 h-3.5 bg-rose-500 rounded-sm"></div>
                    </div>
                    <span class="text-gray-500 text-sm sm:text-base">
                      Exposición automática en 6 portales
                    </span>
                  </div>
                </div>

                <fwb-button
                  @click="() => goToStripe('plan5')"
                  :disabled="!isActiveLocation"
                  class="w-full flex justify-center items-center px-5 py-2.5 bg-rose-500 hover:bg-rose-600 rounded-lg transition-colors duration-200 cursor-pointer"
                >
                  <span class="text-white text-sm font-medium">Cambiar de Plan</span>
                </fwb-button>
              </div>
            </div>

            <!-- Plan 10 propiedades -->
            <div class="w-full max-w-[384px] p-6 sm:p-8 bg-white rounded-lg shadow-md border border-gray-200 flex flex-col">
              <div class="flex-1 flex flex-col gap-7">
                <div class="flex flex-col gap-4">
                  <div class="w-full">
                    <h3 class="text-gray-500 text-lg sm:text-xl font-medium">
                      10 propiedades
                    </h3>
                  </div>
                  <div class="flex items-end gap-2.5">
                    <span class="text-gray-900 text-4xl sm:text-5xl font-extrabold leading-[48px]">
                      ${{ isAnual ? '3,830' : '399' }}
                    </span>
                    <span class="text-gray-500 text-base sm:text-lg font-medium">
                      MXN/{{ isAnual ? 'Anual' : 'Mensual' }}
                    </span>
                  </div>
                </div>

                <div class="flex flex-col gap-4">
                  <div class="flex items-center gap-3">
                    <div class="w-5 h-5 flex items-center justify-center">
                      <div class="w-3.5 h-3.5 bg-rose-500 rounded-sm"></div>
                    </div>
                    <span class="text-gray-500 text-sm sm:text-base">
                      10 propiedades
                    </span>
                  </div>
                  <div class="flex items-center gap-3">
                    <div class="w-5 h-5 flex items-center justify-center">
                      <div class="w-3.5 h-3.5 bg-rose-500 rounded-sm"></div>
                    </div>
                    <span class="text-gray-500 text-sm sm:text-base">
                      Exposición automática en 6 portales
                    </span>
                  </div>
                </div>

                <fwb-button
                  @click="() => goToStripe('plan10')"
                  :disabled="!isActiveLocation"
                  class="w-full flex justify-center items-center px-5 py-2.5 bg-rose-500 hover:bg-rose-600 rounded-lg transition-colors duration-200 cursor-pointer"
                >
                  <span class="text-white text-sm font-medium">Cambiar de Plan</span>
                </fwb-button>
              </div>
            </div>

            <!-- Plan Ilimitado -->
            <div class="w-full max-w-[384px] p-6 sm:p-8 bg-white rounded-lg shadow-md border border-gray-200 flex flex-col">
              <div class="flex-1 flex flex-col gap-7">
                <div class="flex flex-col gap-4">
                  <div class="w-full">
                    <h3 class="text-gray-500 text-lg sm:text-xl font-medium">
                      Ilimitado
                    </h3>
                  </div>
                  <div class="flex items-end gap-2.5">
                    <span class="text-gray-900 text-4xl sm:text-5xl font-extrabold leading-[48px]">
                      ${{ isAnual ? '4,790' : '499' }}
                    </span>
                    <span class="text-gray-500 text-base sm:text-lg font-medium">
                      MXN/{{ isAnual ? 'Anual' : 'Mensual' }}
                    </span>
                  </div>
                </div>

                <div class="flex flex-col gap-4">
                  <div class="flex items-center gap-3">
                    <div class="w-5 h-5 flex items-center justify-center">
                      <div class="w-3.5 h-3.5 bg-rose-500 rounded-sm"></div>
                    </div>
                    <span class="text-gray-500 text-sm sm:text-base">
                      Propiedades ilimitadas
                    </span>
                  </div>
                  <div class="flex items-center gap-3">
                    <div class="w-5 h-5 flex items-center justify-center">
                      <div class="w-3.5 h-3.5 bg-rose-500 rounded-sm"></div>
                    </div>
                    <span class="text-gray-500 text-sm sm:text-base">
                      Exposición automática en 6 portales
                    </span>
                  </div>
                </div>

                <fwb-button
                  @click="() => goToStripe('planPremium')"
                  :disabled="!isActiveLocation"
                  class="w-full flex justify-center items-center px-5 py-2.5 bg-rose-500 hover:bg-rose-600 rounded-lg transition-colors duration-200 cursor-pointer"
                >
                  <span class="text-white text-sm font-medium">Cambiar de Plan</span>
                </fwb-button>
                <!--<fwb-button 
                  @click="openModalForm" 
                  :disabled="!isActiveLocation" 
                  class="w-full flex justify-center items-center px-5 py-2.5 bg-rose-500 hover:bg-rose-600 rounded-lg transition-colors duration-200 cursor-pointer"
                >
                  <span class="text-white text-sm font-medium">Cambiar de Plan</span>
                </fwb-button>-->
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div v-if="showModal" class="fade-in">
      <div v-show="!showPayments">
        <ModalFormNewPayPlanesComponent
          :address="address"
          :export_lat="property_lt"
          :export_ln="property_ln"
          @update-location="handleLocationUpdate"
        />
      </div>
      <div v-if="showPayments">
        <ModalFormPayPlanesComponent
            :address="address"
            :export_lat="property_lt"
            :export_ln="property_ln"
            @update-location="handleLocationUpdate"
          />
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted, computed } from 'vue';
  import ModalFormNewPayPlanesComponent from "@/components/payments/FormPayNewPlanesComponente.vue";
  import ModalFormPayPlanesComponent from "@/components/payments/FormPayPlanesComponent.vue";
  import { useStore } from 'vuex';
  import axios from 'axios';

  const isAnual = ref(false);
  const toastAlert = ref(false);
  const typeMsg = ref('');
  const msg = ref('');
  const tittle = ref('');
  const plans = ref([]);
  const loader_profile = ref(false);
  let showModal = ref(false);
  let showPayments = ref(false);

  const togglePeriod = () => {
    isAnual.value = !isAnual.value;
  };

  let session = computed(() => store.getters.getUserSession);
    
  // Store
  const store = useStore();

  //function openModalForm() {
    //showModal.value = !showModal.value;
  //}

  const isTestEnvironment = () => {
    const apiUrl = process.env.VUE_APP_API_BASE_URL || '';
    return apiUrl.includes('localhost') || apiUrl.includes('qa.tuin.ai');
  };


  function getProfile() {
    showPayments.value = !showPayments.value;
  }

  function goToStripe(planKey) {
    // CASO ESPECIAL: Plan Ilimitado Anual
    if (planKey === 'planPremium' && isAnual.value) {
      const testLink = 'https://buy.stripe.com/test_7sYbJ28x5gHp3Ar14j3sI00';
      const prodLink = 'https://buy.stripe.com/9B614o3cLgHpgndfZd3sI0n'; // Reemplaza con tu link de producción
      
      const paymentLink = isTestEnvironment() ? testLink : prodLink;
      window.open(paymentLink, '_blank');
      return;
    }

    // TODOS LOS DEMÁS PLANES: usar la lógica existente con plans
    const planMapping = {
      plan3: { price: isAnual.value ? 1430 : 149, type: isAnual.value ? 'annual' : 'monthly' },
      plan5: { price: isAnual.value ? 1910 : 199, type: isAnual.value ? 'annual' : 'monthly' },
      plan10: { price: isAnual.value ? 3830 : 399, type: isAnual.value ? 'annual' : 'monthly' },
      planPremium: { price: isAnual.value ? 4790 : 499, type: isAnual.value ? 'annual' : 'monthly' }
    };

    const planInfo = planMapping[planKey];
    if (!planInfo) {
      console.warn('⚠️ No existe configuración para este plan:', planKey);
      return;
    }

    // Buscar el plan en el array plans
    const selectedPlan = plans.value.find(
      plan => plan.price === planInfo.price && plan.type === planInfo.type && plan.status === 'active'
    );

    if (selectedPlan && selectedPlan.payment_link) {
      window.open(selectedPlan.payment_link, '_blank');
    } else {
      console.warn('⚠️ No se encontró un link de pago válido para:', planKey, planInfo);
    }
  }

  // Función para cargar los planes cuando
  async function fetchPlanes() {
    try {
      let options = {
        headers: {
          'Authorization': `Bearer ${session.value.token_api}`
        }
      };
      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/planes-all`, options
      );

      if (response.status === 401) {
        store.dispatch('clearUserSession');
      }

      if (response.status === 200 && response.data?.plans) {
        plans.value = response.data.plans;
        console.log('📋 Planes cargados:', plans.value);
        console.log(`🌍 Entorno: ${isTestEnvironment() ? 'PRUEBA (TEST)' : 'PRODUCCIÓN (LIVE)'}`);
      } else {
        console.error("Error en la respuesta de la API: estructura inesperada");
      }
    } catch (error) {
      console.error("Error al obtener los planes:", error);
    }
  }

  onMounted(async () => {
    try {
      loader_profile.value = false;
      await fetchPlanes();
      await getProfile();
      
    } catch (error) {
      console.error("Error al intentar traer los datos", error);
    }
  });
</script>

<style scoped>
/* Asegurar que Poppins esté disponible */
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');
</style>